import React from "react";

const SvgChevronLeft = props => <svg viewBox="0 0 20 20" {...props}><path fill="currentColor" d="M11.707 15.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 1.414L6.414 10l5.293 5.293z" /></svg>;

export default SvgChevronLeft;